import { AxiosInstance } from "axios";

import accessApi from "./accessApi";
import activityApi from "./activityApi";
import appointableApi from "./appointableApi";
import appointmentApi from "./appointmentApi";
import automationApi from "./automationApi";
import availabilityApi from "./availabilityApi";
import clubApi from "./clubApi";
import companyApi from "./companyApi";
import creditPackApi from "./creditPackApi";
import customerActivityApi from "./customerActivity";
import customerAppointableApi from "./customerAppointableApi";
import customerAppointmentApi from "./customerAppointmentApi";
import customerAvailabilityApi from "./customerAvailabilityApi";
import customerClubApi from "./customerClubApi";
import customerCreditPackApi from "./customerCreditPackApi";
import customerFacilityApi from "./customerFacilityApi";
import customerMembershipApi from "./customerMembershipApi";
import customerOccurrenceApi from "./customerOccurrence";
import customerProductApi from "./customerProductApi";
import emailApi from "./emailApi";
import emailTemplateApi from "./emailTemplateApi";
import eventApi from "./eventApi";
import facilityApi from "./facilityApi";
import hostedClubApi from "./hostedClubApi";
import kisiApi from "./kisiApi";
import leadApi from "./leadApi";
import leadSourceApi from "./leadSourceApi";
import noteApi from "./noteApi";
import onboardingSettingsApi from "./onboardingSettingsApi";
import onboardingSettingsAsMemberApi from "./onboardingSettingsAsMemberApi";
import productApi from "./productApi";
import profileApi from "./profileApi";
import promotionApi from "./promotionApi";
import publicActivityApi from "./publicActivityApi";
import publicAppointableApi from "./publicAppointableApi";
import publicClubApi from "./publicClubApi";
import publicCreditPack from "./publicCreditPackApi";
import publicEventApi from "./publicEventApi";
import publicFacilityApi from "./publicFacilityApi";
import publicHostedClubApi from "./publicHostedClubApi";
import publicLeadApi from "./publicLeadApi";
import publicMembership from "./publicMembershipApi";
import publicHostedRuleApi from "./publicRuleApi";
import publicUserMemberApi from "./publicUserMemberApi";
import revenueApi from "./revenueApi";
import ruleApi from "./ruleApi";
import salesApi from "./salesApi";
import serviceApi from "./serviceApi";
import smsApi from "./smsApi";
import statisticsApi from "./statisticsApi";
import strongCustomerAuthorizationApi from "./strongCustomerAuthorizationApi";
import taskApi from "./taskApi";
import timelineApi from "./timelineApi";
import userMemberApi from "./userMemberApi";
import userStaffApi from "./userStaffApi";
import xeroApi from "./xeroApi";
import zapierApi from "./zapierApi";

export * from "../createAxiosInstance";
export { default as DurationType } from "./DurationType";
export {
  PARAMETER_DATE_FORMAT,
  PARAMETER_DATE_FORMAT_WITHOUT_TZ,
  PARAMETER_DATE_ONLY_FORMAT,
  PARAMETER_TIME_FORMAT,
} from "./eventApi";
export { default as ExpiryType } from "./ExpiryType";
export { default as GuestStatus } from "./GuestStatus";
export { default as permissions } from "./permissions";
export { default as ProductStockType } from "./ProductStockType";
export { default as RecurringType } from "./RecurringType";
export { default as ServiceType } from "./ServiceType";
export {
  EVENT_FIELD,
  MEMBERSHIP_FIELD,
  REVENUE_FIELD,
  STATISTICS_CATEGORY,
} from "./statisticsApi";
export { default as SubscriptionStatus } from "./SubscriptionStatus";
export { default as UserRole } from "./UserRole";

export const gymflowApi = ({
  apiUrl,
  axiosInstance,
  clubId,
}: {
  apiUrl: string;
  axiosInstance: AxiosInstance;
  clubId: number;
}) => {
  const publicApis = {
    public: {
      userMemberApi: publicUserMemberApi(apiUrl, clubId),
      creditPackApi: publicCreditPack(apiUrl, clubId),
      membershipApi: publicMembership(apiUrl, clubId),
      clubApi: publicClubApi(apiUrl, clubId),
      eventApi: publicEventApi(apiUrl, clubId),
      hostedClubApi: publicHostedClubApi(apiUrl, clubId),
      ruleApi: publicHostedRuleApi(apiUrl, clubId),
      leadApi: publicLeadApi(apiUrl, clubId),
      facilityApi: publicFacilityApi(apiUrl, clubId),
      activityApi: publicActivityApi(apiUrl, clubId),
      appointableApi: publicAppointableApi(apiUrl, clubId),
    },
  };

  return {
    activityApi: activityApi(axiosInstance, clubId),
    clubApi: clubApi(axiosInstance, clubId),
    companyApi: companyApi(axiosInstance, clubId),
    creditPackApi: creditPackApi(axiosInstance, clubId),
    customerClubApi: customerClubApi(axiosInstance, clubId),
    customerOccurrenceApi: customerOccurrenceApi(axiosInstance, clubId),
    customerProductApi: customerProductApi(axiosInstance, clubId),
    customerActivityApi: customerActivityApi(axiosInstance, clubId),
    customerFacilityApi: customerFacilityApi(axiosInstance, clubId),
    customerAvailabilityApi: customerAvailabilityApi(axiosInstance, clubId),
    customerAppointableApi: customerAppointableApi(axiosInstance, clubId),
    eventApi: eventApi(axiosInstance, clubId),
    facilityApi: facilityApi(axiosInstance, clubId),
    productApi: productApi(axiosInstance, clubId),
    profileApi: profileApi(axiosInstance, clubId),
    serviceApi: serviceApi(axiosInstance, clubId),
    leadSourceApi: leadSourceApi(axiosInstance, clubId),
    staffApi: userStaffApi(axiosInstance, clubId),
    statisticsApi: statisticsApi(axiosInstance, clubId),
    memberApi: userMemberApi(axiosInstance, clubId),
    hostedClubApi: hostedClubApi(axiosInstance, clubId),
    noteApi: noteApi(axiosInstance, clubId),
    timelineApi: timelineApi(axiosInstance, clubId),
    ruleApi: ruleApi(axiosInstance, clubId),
    leadApi: leadApi(axiosInstance, clubId),
    automationApi: automationApi(axiosInstance, clubId),
    emailTemplateApi: emailTemplateApi(axiosInstance, clubId),
    revenueApi: revenueApi(axiosInstance, clubId),
    accessApi: accessApi(axiosInstance, clubId),
    emailApi: emailApi(axiosInstance, clubId),
    smsApi: smsApi(axiosInstance, clubId),
    taskApi: taskApi(axiosInstance, clubId),
    strongCustomerAuthorizationApi: strongCustomerAuthorizationApi(
      axiosInstance,
      clubId,
    ),
    salesApi: salesApi(axiosInstance, clubId),
    promotionApi: promotionApi(axiosInstance, clubId),
    kisiApi: kisiApi(axiosInstance, clubId),
    xeroApi: xeroApi(axiosInstance, clubId),
    zapierApi: zapierApi(axiosInstance, clubId),
    appointableApi: appointableApi(axiosInstance, clubId),
    availabilityApi: availabilityApi(axiosInstance, clubId),
    appointmentApi: appointmentApi(axiosInstance, clubId),
    customerAppointmentApi: customerAppointmentApi(axiosInstance, clubId),
    customerCreditPackApi: customerCreditPackApi(axiosInstance, clubId),
    customerMembershipApi: customerMembershipApi(axiosInstance, clubId),
    onboardingSettingsApi: onboardingSettingsApi(axiosInstance, clubId),
    onboardingSettingsAsMemberApi: onboardingSettingsAsMemberApi(
      axiosInstance,
      clubId,
    ),
    ...publicApis,
  };
};

export type ApiType = ReturnType<typeof gymflowApi>;
